module.exports = __webpack_public_path__ + "img/bg1.4850d1d9.gif";